module.exports = __webpack_public_path__ + "media/images/performance-group-f726afdf90f61e394c742bf522cb51d3.png";